import { isMobileResolution, isTabletResolution } from "./utils/utils";

export const initWidget = () => {
  const widgetList = document.querySelector<HTMLDivElement>(".widget__list");

  if (!widgetList) return;

  if (isMobileResolution() || isTabletResolution()) {
    widgetList.addEventListener("click", (event: PointerEvent) => {
      const { target } = event;

      widgetList.classList.add("--visible");
    });

    document.addEventListener("click", (event: PointerEvent) => {
      const { target } = event;

      if (!widgetList.contains(target as HTMLElement)) {
        widgetList.classList.remove("--visible");
      }
    });
  }
};
